import type { ColumnDef, RowData } from '@tanstack/react-table'

export const Z_INDEX: Record<'head' | 'body' | 'footer', number> = {
  head: 10,
  body: 0,
  footer: 10
}

export const headerIconSize = {
  width: 24,
  height: 24
}

export const ROW_SELECTION_COLUMN_ID = 'row-selection'

export const ROW_SELECTION_COLUMN_DEF: ColumnDef<RowData> = {
  id: ROW_SELECTION_COLUMN_ID,
  size: 48,
  meta: {
    chartCard: {
      fixedSize: true
    }
  }
}

export const SCROLL_ACTIVATION_MARGIN_PX = 48
export const SCROLL_MAX_STEP = 14
export const COLUMN_ID_DATA_ATTR = 'data-column-id'
